<div class="profile-glass" [class.collapsed]="sidebarCollapsed" (click)="openDrawerUserProfileEditComponent()"
    nz-tooltip [nzTooltipTitle]=" sidebarCollapsed ? ('profil.title' | translate) : ''" [nzTooltipPlacement]="'right'"
    [nzTooltipColor]="derichebourgColorBlue">
    <div class="glass-container">
        <nz-avatar class="avatar-glow" [nzText]="avatarText" nzSize="large" nzShape="circle"
            [ngStyle]="{'background': 'linear-gradient(135deg, #005a82 0%, #0a7fa5 100%)', 'color': 'white', 'font-weight': '700', 'box-shadow': '0 3px 8px rgba(0, 90, 130, 0.3)'}"></nz-avatar>
        @if (!sidebarCollapsed) {
        <div class="profile-info-glass">
            <p class="name">{{userDisplayName}}</p>
            <p class="subtitle">{{ 'profil.manageProfile' | translate }}</p>
        </div>
        }
    </div>
</div>

<ng-template #drawerClose>
    <button nz-button nzType="default" (click)="closeDrawer()">
        <span nz-icon nzType="close" nzTheme="outline"></span>
        {{ 'common.close' | translate }}</button>
</ng-template>